import { TextInput } from '../baseInputs'

type Props = {
  name?: string
  helper?: string
  optional?: boolean
  label?: string
}

const AgreementNo = ({
  name: inputName,
  helper,
  optional,
  label: inputLabel,
  ...rest
}: Props) => {
  const name = inputName || 'agreement_or_reg_num'
  const label = inputLabel || 'Agreement OR Registration number'

  return (
    <TextInput
      name={name}
      label={label}
      helper={helper}
      optional={optional}
      uppercase={true}
      {...rest}
    />
  )
}

export default AgreementNo
